import createApiRequest from '@/lib/axios/createApiRequest';

export default function postConstituentIWave({
  constituentId,
  iwaveUniqueScreeningId,
  ownerOrgId,
}: {
  constituentId: string;
  iwaveUniqueScreeningId: string;
  ownerOrgId: string;
}) {
  return createApiRequest({
    path: 'integrations/iwave/import-score',
    data: {
      constituentId,
      iwaveUniqueScreeningId,
      ownerOrgId,
    },
    throwErrors: true,
  });
}
